/** Client mirror of server food discovery outcome labels. */

export function getFoodDiscoveryOutcome(source = {}) {
  const status = source.discoveryStatus || "NOT_STARTED";
  const risk = source.ingestionRiskLevel || "MEDIUM";

  if (status === "PUBLIC_PRICE_CONFIRMED") {
    if (risk === "DO_NOT_INGEST") {
      return {
        label: "Public prices confirmed — blocked by ingestion risk",
        tone: "warning",
        recommendation: "DO_NOT_INGEST",
      };
    }
    return {
      label: "Public prices confirmed — ready for ingestion PoC",
      tone: "success",
      recommendation: "PROCEED_TO_RETAIL_INGESTION_POC",
    };
  }

  if (status === "NO_PUBLIC_PRICE_FOUND") {
    return {
      label: "No public prices found — do not build provider yet",
      tone: "warning",
      recommendation: "REVIEW_ANOTHER_SOURCE_FIRST",
    };
  }

  if (status === "LOGIN_REQUIRED") {
    return {
      label: "Login required — not supported",
      tone: "danger",
      recommendation: "DO_NOT_INGEST",
    };
  }

  if (status === "APP_ONLY") {
    return {
      label: "App-only prices — not supported on public web",
      tone: "danger",
      recommendation: "DO_NOT_INGEST",
    };
  }

  if (status === "BLOCKED_OR_UNSAFE" || risk === "DO_NOT_INGEST") {
    return {
      label: "Blocked or unsafe — do not ingest",
      tone: "danger",
      recommendation: "DO_NOT_INGEST",
    };
  }

  if (status === "NEEDS_MANUAL_REVIEW" || status === "IN_REVIEW") {
    return {
      label: "Needs manual review — incomplete evidence",
      tone: "neutral",
      recommendation: "NEEDS_MANUAL_REVIEW",
    };
  }

  return {
    label: "Discovery not started — review required before ingestion PoC",
    tone: "neutral",
    recommendation: "NEEDS_MANUAL_REVIEW",
  };
}
